module.exports = __webpack_public_path__ + "390141d5fab7636dbabef04db223ca1b.png";